module.exports = __webpack_public_path__ + "img/theodore-alexander-desktop-compressed.7d1ff2d.png";